"use strict";

exports.__esModule = true;
var _TabsElement = require("./TabsElement");
Object.keys(_TabsElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabsElement[key]) return;
  exports[key] = _TabsElement[key];
});
var _TabsThumbnail = require("./TabsThumbnail");
Object.keys(_TabsThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabsThumbnail[key]) return;
  exports[key] = _TabsThumbnail[key];
});
var _TabsFields = require("./TabsFields");
Object.keys(_TabsFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabsFields[key]) return;
  exports[key] = _TabsFields[key];
});
var _TabsHeader = require("./TabsHeader");
Object.keys(_TabsHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabsHeader[key]) return;
  exports[key] = _TabsHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});